var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WsStateDropdownCheckboxInputAvatar001',{attrs:{"required":"","outline":"","title":"填表人員","leading-icon":"icon-outline-perm-identity","rules":"required","placeholder":"填表人員填表人員"},model:{value:(_vm.state),callback:function ($$v) {_vm.state=$$v},expression:"state"}})
}
var staticRenderFns = []

export { render, staticRenderFns }